export const multiOfferMockedData = [
    {
        status: 'success',
        programCode: 'WL30',
        offerTitle: 'Platinum Visa for Rebuilding Credit',
        offerImage:
            '/content/dam/creditonebank/corporate-transactional/images/card-compare/platinum-visa-blue.png',
        offerImageAltText: 'Platinum Visa',
        isMostPopular: true,
        creditLineText: 'Credit line is up to $2,500',
        bulletText: [
            '1% cash back rewards on eligible purchases of gas, grocery, and internet, cable, satellite TV and mobile phone services',
            'Free credit score accessible online',
        ],
        programRates: {
            IntroAnnualMembership: 75,
            AnnualMembership: 99,
            BilledMonthlyMembership: 8.25,
            BaseRate: 20.74,
            MaximumRate: 99.9,
            CalculatedPurchaseRate: 28.74,
            CalculatedCashRate: 28.74,
            IsAmortizedProgram: false,
            Errors: [],
        },
        CardDesign: {
            Cards: [
                {
                    'Selected': false,
                    'CardName': 'Blue',
                    'CardDescription': 'Blue',
                    'PremiumFee': 0,
                    'PlasticId': '10760',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 1,
                    'Code': 'BU',
                },
                {
                    'Selected': false,
                    'CardName': 'Silver',
                    'CardDescription': 'Silver',
                    'PremiumFee': 0,
                    'PlasticId': '10759',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 2,
                    'Code': 'BR',
                },
                {
                    'Selected': false,
                    'CardName': 'Pink',
                    'CardDescription': 'Pink',
                    'PremiumFee': 6.95,
                    'PlasticId': '10758',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 3,
                    'Code': 'BN',
                },
                {
                    'Selected': false,
                    'CardName': 'Black',
                    'CardDescription': 'Black',
                    'PremiumFee': 6.95,
                    'PlasticId': '10757',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 4,
                    'Code': 'BQ',
                },
                {
                    'Selected': false,
                    'CardName': 'Sapphire Blue',
                    'CardDescription': 'Sapphire Blue',
                    'PremiumFee': 6.95,
                    'PlasticId': '10756',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 5,
                    'Code': 'ED',
                },
                {
                    'Selected': false,
                    'CardName': 'Purple Lapis',
                    'CardDescription': 'Purple Lapis',
                    'PremiumFee': 6.95,
                    'PlasticId': '10755',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 6,
                    'Code': 'EE',
                },
                {
                    'Selected': false,
                    'CardName': 'Emerald Green',
                    'CardDescription': 'Emerald Green',
                    'PremiumFee': 6.95,
                    'PlasticId': '10754',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 7,
                    'Code': 'EG',
                },
                {
                    'Selected': false,
                    'CardName': 'Pink Quartz',
                    'CardDescription': 'Pink Quartz',
                    'PremiumFee': 6.95,
                    'PlasticId': '10753',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 8,
                    'Code': 'EF',
                },
                {
                    'Selected': false,
                    'CardName': 'VGK Black on Black',
                    'CardDescription': 'VGK Black on Black',
                    'PremiumFee': 6.95,
                    'PlasticId': '10762',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 9,
                    'Code': 'DT',
                },
                {
                    'Selected': false,
                    'CardName': 'VGK Gold Shield',
                    'CardDescription': 'VGK Gold Shield',
                    'PremiumFee': 6.95,
                    'PlasticId': '10764',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 10,
                    'Code': 'DQ',
                },
                {
                    'Selected': false,
                    'CardName': 'VGK Red Sword',
                    'CardDescription': 'VGK Red Sword',
                    'PremiumFee': 6.95,
                    'PlasticId': '10763',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 11,
                    'Code': 'DR',
                },
                {
                    'Selected': false,
                    'CardName': 'VGK Stripe',
                    'CardDescription': 'VGK Stripe',
                    'PremiumFee': 6.95,
                    'PlasticId': '10765',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 12,
                    'Code': 'DP',
                },
                {
                    'Selected': false,
                    'CardName': 'VGK Military',
                    'CardDescription': 'VGK Military',
                    'PremiumFee': 6.95,
                    'PlasticId': '10761',
                    'IsFeeRecurring': true,
                    'PlasticDesc': null,
                    'IsPremium': true,
                    'ProgramPlasticCode': 13,
                    'Code': 'DS',
                },
            ],
        },
    },
    {
        status: 'success',
        programCode: 'WL26',
        offerTitle: 'Platinum Visa',
        offerImage:
            '/content/dam/creditonebank/corporate-transactional/images/card-compare/platinum-suite-visa.png',
        offerImageAltText: 'Platinum Visa',
        isMostPopular: false,
        creditLineText: 'Credit line is up to $2,500',
        bulletText: [
            'Unlimited 1% cash back rewards on eligible purchases of gas, grocery, and internet, cable, satellite TV and mobile phone services',
            '$0 Fraud Liability protects you against unauthorized charges',

        ],
        programRates: {
            ProgramRatesId: 0,
            ProgramCode: 'WL26',
            InitialCredit: 300,
            IntroAnnualMembership: 39,
            AnnualMembership: 39,
            BilledMonthlyMembership: 0,
            BaseRate: 20.74,
            MaximumRate: 99.9,
            CalculatedPurchaseRate: 28.74,
            CalculatedCashRate: 28.74,
            PurchaseBalanceRateTypeCode: 'V',
            CashBalanceRateTypeCode: 'V',
            IsAmortizedProgram: false,
            Errors: [],
        },
        CardDesign: {
            Cards: [
                {
                    'Selected': false,
                    'CardName': 'Deep Red',
                    'CardDescription': 'Deep Red',
                    'PremiumFee': 0,
                    'PlasticId': '8818',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 1,
                    'Code': 'CN',
                },
                {
                    'Selected': false,
                    'CardName': 'Black',
                    'CardDescription': 'Black',
                    'PremiumFee': 0,
                    'PlasticId': '8819',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 2,
                    'Code': 'BQ',
                },
                {
                    'Selected': false,
                    'CardName': 'Rose Gold',
                    'CardDescription': 'Rose Gold',
                    'PremiumFee': 0,
                    'PlasticId': '8820',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 3,
                    'Code': 'CL',
                },
                {
                    'Selected': false,
                    'CardName': 'Light Blue',
                    'CardDescription': 'Light Blue',
                    'PremiumFee': 0,
                    'PlasticId': '8821',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 4,
                    'Code': 'CO',
                },
            ],

        },
    },
    {
        status: 'success',
        programCode: 'WKL6',
        offerTitle: 'Credit One Bank American Express<sup>®</sup>',
        offerImage:
            '/content/dam/creditonebank/corporate-transactional/images/card-compare/preferred-amex-cobalt.png',
        offerImageAltText: 'Credit One Bank American Express',
        isMostPopular: false,
        creditLineText: 'Credit line is up to $2,500',
        bulletText: [
            'Unlimited 1% cash back rewards on all purchases',
            'Retail protection covers eligible purchases',

        ],
        programRates: {
            ProgramRatesId: 0,
            ProgramCode: 'WKL6',
            InitialCredit: 300,
            IntroAnnualMembership: 39,
            AnnualMembership: 39,
            BilledMonthlyMembership: 0,
            BaseRate: 20.74,
            MaximumRate: 99.9,
            CalculatedPurchaseRate: 28.74,
            CalculatedCashRate: 28.74,
            PurchaseBalanceRateTypeCode: 'V',
            CashBalanceRateTypeCode: 'V',
            IsAmortizedProgram: false,
            Errors: [],
        },
        CardDesign: {
            Cards: [
                {
                    'Selected': false,
                    'CardName': 'Cobalt',
                    'CardDescription': 'Cobalt',
                    'PremiumFee': 0,
                    'PlasticId': '8970',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 1,
                    'Code': 'CE',
                },
                {
                    'Selected': false,
                    'CardName': 'Mint',
                    'CardDescription': 'Mint',
                    'PremiumFee': 0,
                    'PlasticId': '8971',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 2,
                    'Code': 'CD',
                },
                {
                    'Selected': false,
                    'CardName': 'Steel',
                    'CardDescription': 'Steel',
                    'PremiumFee': 0,
                    'PlasticId': '8972',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 3,
                    'Code': 'CF',
                },
                {
                    'Selected': false,
                    'CardName': 'Ultra',
                    'CardDescription': 'Ultra',
                    'PremiumFee': 0,
                    'PlasticId': '8973',
                    'IsFeeRecurring': false,
                    'PlasticDesc': null,
                    'IsPremium': false,
                    'ProgramPlasticCode': 4,
                    'Code': 'CG',
                },
            ],

        },
    },
];
